<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex"/>
    <el-main>
      <div
          style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 52px); min-width:1200px;overflow: auto;"
          v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="edit" style="height: 40px !important;">
          <form @submit.prevent="submitForm">
            <div class="form-group" style=" display: flex;width: 1000px;">
              <div class="form_inline">
                <el-date-picker style="width: 137px;margin-left: 6px;" clearable v-model="value0" type="month"
                                align="right" unlink-panels range-separator="" placeholder="工资月份" end-placeholder=""
                                @change="getList">
                </el-date-picker>
              </div>
              <div class="form-inline" style="width: 148px;height:28px;font-size:12px;">
                <el-select v-model="jsbm" filterable placeholder="结算部门" @change="jsbmChange"
                           style="margin-left: 6px;" clearable :class="{ 'vip': jsbm && jsbm !== '结算部门' }">
                  <el-option v-for="(value, key) in jsbm_one" :key="key" :label="value.name" :value="value.id">
                  </el-option>
                </el-select>
              </div>
              <div class="form-inline" style="width:400px;height:28px;font-size:12px;"
                   v-if="role != 8"
              >
                <button type="submit" class="btn btn-primary" @click="sendDataToBackend">保存</button>
                <button type="button" class="btn btn-danger" @click="deleteForm">删除</button>
                <button type="button" class="btn btn-success" @click="exportExcel">Excel</button>
              </div>
            </div>
          </form>
        </div>
        <div style="display: flex;margin-top: 3px ">
          <div v-if="role != 8" id="addRow" class="order-list" name="addRow" @click="coulunmEvt">添加行</div>
          <div v-if="role != 8" id="addCell" class="order-list" name="addCell" @click="rowEvt">添加列</div>
          <div class="order_div" style="width: 1050px;display: flex;justify-content: space-between;">
            <span style="color: #8d8d8d;">总产值：<span style="color: #000;">{{ totalRow_one.division }}</span></span>

            <span style="color: #8d8d8d;">总回款金额：<span style="color: #000;">{{
                totalRow_one.backed_amount
              }}</span></span>
            <span style="color: #8d8d8d;">总雇佣成本：<span style="color: #000;">{{
                totalRow_one.employment
              }} </span></span>
            <span style="color: #8d8d8d;">总工作量：<span style="color: #000;">{{
                totalRow_one.workload
              }}</span></span>
            <span style="color: #8d8d8d;"> 单位工作量产值：<span style="color: #000;">{{
                totalRow_one.unit_division
              }}</span></span>
            <span style="color: #8d8d8d;">单位工作量成本：<span style="color: #000;">{{
                totalRow_one.cost
              }}</span></span>
            <span style="color: #8d8d8d;">成本产值比<span style="color: #000;">{{
                totalRow_one.division_employment
              }}</span>%</span>
          </div>
        </div>
        <div
            style="width:calc(100% - 130px);height: calc(100vh - 140px); overflow: auto; margin-top: 10px;padding-bottom: 10px;"
            class="maxs">
          <template v-if="role == 8">
            <table class="ma_ev" style="position: relative;">
              <!-- 表头 -->
              <thead id="newhead"></thead>

              <!-- 表体 -->
              <tbody id="newbody">
              <!-- 工资项行 -->
              <tr v-for="(row, rowIndex) in salaryRows" :key="rowIndex" class="order-flexs">
                <td class="order-input">{{ row.title }}</td>
                <!-- 如果是总工作量行，则添加额外的列 -->
                <template v-if="row.title === '总工作量'">
                  <td>项目划分产值</td>
                  <td>回款金额</td>
                  <td>项目成本</td>
                  <td>项目总工程量</td>
                  <td>工作量产值</td>
                  <td>成本产值比</td>
                </template>
                <template v-else>
                  <!-- 对于其他行，按原样处理 -->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </template>
              </tr>

              <!-- 项目划分部分 -->
              <tr v-for="(item, index) in tableData.salaryProjects" :key="item.id" class="lie" ref="orderFlexs">
                <td style="position: relative; ">
                  <el-select class="my-row " style="width: 300px;"
                             v-model="item.project_name"
                             filterable
                             placeholder="请选择项目"
                             :id="`${item.project_id}`"
                             disabled
                             @change="updateEvt(item,index)"
                  >
                    <el-option
                        v-for="project in projectItem"
                        :key="project.id"
                        :label="project.name"
                        :value="project.name"
                        disabled
                    />
                  </el-select>
                  <img
                      src="../../../images/clone_1.png"
                      alt="delete"
                      class="clone_one"
                      style="width: 15px; height: 15px; position: absolute; right: 0; top: 0px;"
                      @click="delete_one(index)"
                  />
                </td>
                <td :style="{ color: getTextOrZeroColor(item.division) }">{{ item.division }}</td>
                <td :style="{ color: getTextOrZeroColor(item.backed_amount) }">{{ item.backed_amount }}</td>
                <td :style="{ color: getTextOrZeroColor(item.cost) }">{{ item.cost }}</td>
                <td :style="{ color: getTextOrZeroColor(item.quantities) }">{{ item.quantities }}</td>
                <td :style="{ color: getTextOrZeroColor(item.production) }">{{ item.production }}</td>
                <td :style="{ color: getTextOrZeroColor(item.value_ratio) }">
                  {{ item.value_ratio }}
                  <span v-if="isNaN(parseFloat(item.value_ratio)) ? false : parseFloat(item.value_ratio) !== 0">%</span>
                </td>
              </tr>
              </tbody>
            </table>
          </template>
          <template v-else>
            <table class="ma_ev" style="position: relative;">
              <!-- 表头 -->
              <thead id="newhead">
              <tr class="order-flexs" style="background-color: #fff;">
                <td class="order-input" v-for="n in 7" :key="'fixed-' + n"></td>

                <!-- 动态员工列 -->
                <td v-for="(item, index) in tableData.salary" :key="index" style="position: relative;width:100px;"
                    class="fixed_e">
                  <el-select class="my-select"
                             v-model="item.staff_name"
                             filterable
                             placeholder=""
                             @change="updateId(item)"
                             :id="`${item.staff_id}`"
                             data-name="item.staff_name"
                  >
                    <el-option
                        v-for="staff in staffItem"
                        :key="staff.id"
                        :label="staff.name"
                        :value="staff.name"
                    />
                  </el-select>
                  <img
                      src="../../../images/clone_1.png"
                      alt="delete"
                      class="clone_one"
                      style="width: 15px; height: 15px; position: absolute; right: 0; top: 0px;"
                      @click="deleteItem(index)"
                  />
                </td>
              </tr>
              </thead>

              <!-- 表体 -->
              <tbody id="newbody">
              <!-- 工资项行 -->
              <tr v-for="(row, rowIndex) in salaryRows" :key="rowIndex" class="order-flexs">
                <td class="order-input">{{ row.title }}</td>
                <!-- 如果是总工作量行，则添加额外的列 -->
                <template v-if="row.title === '总工作量'">
                  <td>项目划分产值</td>
                  <td>回款金额</td>
                  <td>项目成本</td>
                  <td>项目总工程量</td>
                  <td>工作量产值</td>
                  <td>成本产值比</td>
                </template>
                <template v-else>
                  <!-- 对于其他行，按原样处理 -->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </template>
                <td v-for="(val, valIndex) in salary" :key="valIndex" class="order-tr">
                  <input
                      :readonly="row.readonly"
                      :value="val[row.field]"
                      @input="handleInput(val, row.field, $event)"
                      :style="{ color: getTextColor(val[row.field]) }"
                  />
                </td>
              </tr>

              <!-- 项目划分部分 -->
              <tr v-for="(item, index) in tableData.salaryProjects" :key="item.id" class="lie" ref="orderFlexs">
                <td style="position: relative; ">
                  <el-select class="my-row " style="width: 300px;"
                             v-model="item.project_name"
                             filterable
                             placeholder="请选择项目"
                             :id="`${item.project_id}`"
                             @change="updateEvt(item,index)"
                  >
                    <el-option
                        v-for="project in projectItem"
                        :key="project.id"
                        :label="project.name"
                        :value="project.name"
                    />
                  </el-select>
                  <img
                      src="../../../images/clone_1.png"
                      alt="delete"
                      class="clone_one"
                      style="width: 15px; height: 15px; position: absolute; right: 0; top: 0px;"
                      @click="delete_one(index)"
                  />
                </td>
                <td :style="{ color: getTextOrZeroColor(item.division) }">{{ item.division }}</td>
                <td :style="{ color: getTextOrZeroColor(item.backed_amount) }">{{ item.backed_amount }}</td>
                <td :style="{ color: getTextOrZeroColor(item.cost) }">{{ item.cost }}</td>
                <td :style="{ color: getTextOrZeroColor(item.quantities) }">{{ item.quantities }}</td>
                <td :style="{ color: getTextOrZeroColor(item.production) }">{{ item.production }}</td>
                <td :style="{ color: getTextOrZeroColor(item.value_ratio) }">
                  {{ item.value_ratio }}
                  <span v-if="isNaN(parseFloat(item.value_ratio)) ? false : parseFloat(item.value_ratio) !== 0">%</span>
                </td>

                <!-- 员工工作量输入 -->
                <template v-if="projectStaff[item.project_id]">
                  <td class="hover-effect" v-for="(staffWorkItem, staffIndex) in getStaffWorkItems(item.project_id)"
                      :key="'staffWork-' + staffIndex">
                    <input type="text" :value="staffWorkItem.workload === '0.0' ? '' : staffWorkItem.workload"/>
                  </td>
                </template>
              </tr>
              </tbody>
            </table>
          </template>

        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import Vue from 'vue';
import {IndexApi, SearchApi, SaveApi} from "@/api/salary/index.js"
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {StatusApi} from "../../../api/work";

export default {
  components: {
    GlobalHeader,
    vSelect
  },
  data() {

    return {
      activeIndex: "4-1",
      headerr: null,
      ti_time: '',
      settlement: '',
      name_security: '',
      ga_security: '',

      leader: [], // 填写人数据
      work_type: [], // 工种数据

      staff: [],// 填充你的staff数据

      changing: 1,
      tableData: [],
      salary: [], // 填充你的salary数
      totalRow_one: [],
      staffItem: [],
      projectItem: [],
      projectStaff: {}, // 项目与员工工作量映射
      projects: [],
      selectedValues: [],// 存储每个下拉选择框的值
      deductions: null,

      selectedStaff: '', // 初始化选中的员工数组

      jsbm: [], // 结算部门数据
      jsbm_one: null,
      value0: '',

      eVt: null,
      isOpen: null,
      loading: false,
      role: null,
    };
  },
  created() {

    SearchApi().then(res => {
      this.staffItem = res.data.staff
      this.projectItem = res.data.project
      this.jsbm_one = res.data.jsbm
    })
    StatusApi().then(res => {
      this.role = res.user.role
    })
  },
  computed: {
    salaryRows() {
      return [
        {title: "雇佣成本", field: "employment", readonly: true},
        {title: "到手工资", field: "payable", readonly: true},
        {title: "底薪津贴", field: "allowance", readonly: false},
        {title: "实际提成", field: "commission", readonly: false},
        {title: "计算提成", field: "calculate", readonly: true},
        {title: "实际提成和计算提成的差额", field: "calculate_num", readonly: true},
        {title: "其他奖励", field: "rewards", readonly: false},
        {title: "其他扣款", field: "deductions", readonly: false},
        {title: "个人社保扣除", field: "security", readonly: false},
        {title: "个税扣除", field: "income", readonly: false},
        {title: "公司社保支付", field: "security_payment", readonly: false},
        {title: "单位工作量", field: "workload", readonly: false},
        {title: "总工作量", field: "quantities", readonly: true}
      ];
    },
    getStaffWorkItems() {
      return function (projectId) {
        // 返回对应projectId的员工工作项数据，如果不存在则返回一个空数组
        return this.projectStaff[projectId] || [];
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick);

  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {


    updateId(item) {
      const matched = this.staffItem.find(staff => staff.name === item.staff_name);
      if (matched) item.staff_id = matched.id || '';
    },
    updateEvt(item, index) {
      this.$nextTick(() => {
        const matched = this.projectItem.find(project => project.name === item.project_name);
        if (matched) {
          const newProjectId = matched.id || '';
          console.log(matched, 321312);

          // 设置新的 project_id
          item.project_id = newProjectId;

          // 检查是否存在该 projectId 的 staff 数据
          if (!this.projectStaff.hasOwnProperty(newProjectId)) {
            let tdCount = 0;
            const currentRow = this.$refs.orderFlexs[index];
            console.log(currentRow, 222);
            console.log(index, 213);

            // 查找上一行的 td 数量
            // 如果 index == 0，则查找整个页面中的 .order-flexs 元素
            if (index == 0) {
              const orderFlexsElements = document.querySelectorAll('.order-flexs');
              console.log(orderFlexsElements, 2232323);

              for (let i = 0; i < orderFlexsElements.length; i++) {
                const trElement = orderFlexsElements[i];
                const tdElements = trElement.querySelectorAll('td.order-tr'); // 确保这里的选择器是正确的

                if (tdElements.length > 0) {
                  tdCount = tdElements.length
                  break; // 找到后退出循环
                } else {
                  tdCount = tdElements.length
                }
              }
            } else if (index > 0) {
              const prevRow = currentRow.previousElementSibling;
              console.log(prevRow, 1233123);
              if (prevRow) {
                tdCount = prevRow.querySelectorAll('.hover-effect').length;
                console.log(tdCount, 1);
              }
            }

            // 初始化数据
            const initData = Array(tdCount).fill().map(() => ({workload: '0.0'}));

            // 使用 Vue.set 来确保响应性
            Vue.set(this.projectStaff, newProjectId, initData);
          }
        }
      });
    },


    deleteItem(logicalIndex) {
      const salaryArray = this.tableData.salary;

      if (!Array.isArray(salaryArray)) {
        console.error('tableData.salary 不是数组');
        return;
      }

      if (logicalIndex < 0 || logicalIndex >= salaryArray.length) {
        console.warn('无效的索引:', logicalIndex);
        return;
      }

      // 安全地删除
      salaryArray.splice(logicalIndex, 1);

      // 同步删除 salaryRows 中对应列的数据
      if (this.salaryRows && Array.isArray(this.salaryRows)) {
        this.salaryRows.forEach(row => {
          if (Array.isArray(row.values) && logicalIndex < row.values.length) {
            row.values.splice(logicalIndex, 1);
          }
        });
      }
      // 同步删除每个项目对应的员工工作量数据
      if (this.tableData.salaryProjects && Array.isArray(this.tableData.salaryProjects)) {
        this.tableData.salaryProjects.forEach(project => {
          const staffWorkloads = this.projectStaff[project.project_id];
          if (Array.isArray(staffWorkloads) && logicalIndex < staffWorkloads.length) {
            staffWorkloads.splice(logicalIndex, 1);
          }
        });
      }

      // 确保 DOM 更新完成后再进行后续操作
      this.$nextTick(() => {
        const rows = document.querySelectorAll('tr'); // 获取所有的行
        rows.forEach((row, index) => {
          if (row.classList.contains('newCellClass')) { // 检查是否为 newCellClass
            // 查找前面最近的 lie tr 只是为了记录目的
            for (let i = index - 1; i >= 0; i--) {
              if (rows[i].classList.contains('lie')) {
                break; // 找到后退出循环
              }
            }
            const tds = row.querySelectorAll('td');
            if (tds.length > 0) {
              const lastTd = tds[tds.length - 1]; // 获取最后一个 td
              lastTd.remove(); // 删除最后一个 td
            }
          }
        });
      });
    },
    delete_one(index) {
      this.tableData.salaryProjects.splice(index, 1);
    },
    handleSelectOpen(open, index) {
      if (open) this.onOpen(index);
      else this.onClose(index);
    },

    handleInput(val, field, event) {
      let newValue = event.target.value;
      // 去掉前导零
      if (newValue !== '') {
        newValue = newValue.replace(/^0+/, '') || '0';
      }
      // 更新 input 显示的值（这一步会影响输入框显示）
      event.target.value = newValue;
      // 设置字体颜色：如果是 0 则浅色，否则黑色
      if (newValue === '0') {
        event.target.style.color = '#d7e9ea';
      } else {
        event.target.style.color = '#000';
      }
    },

    getTextColor(value) {
      return value === 0 || value === '0.0' ? '#d7e9ea' : '#000';
    },

    getTextOrZeroColor(value) {
      return this.getTextColor(value);
    },
    onOpen(index) {
      console.log("onOpen:", index);
      if (this.isOpen !== null && this.isOpen !== index) {
        // 如果有其他下拉框已经打开，则手动关闭它
        console.log("Closing previous dropdown:", this.isOpen);
        this.closeDropdown(this.isOpen);
      }
      this.isOpen = index; // 更新当前打开的下拉框索引
      console.log("Current open dropdown:", this.isOpen);
    },
    onClose(index) {
      console.log("onClose:", index);
      if (this.isOpen === index) {
        console.log("Closing current dropdown:", index);
        this.isOpen = null; // 当前下拉框关闭时清空索引
      }
    },
    closeDropdown(index) {
      // 手动关闭指定索引的下拉框
      const selectElement = this.$refs.selects[index];
      if (selectElement) {
        selectElement.open = false; // 使用 vue-select 的 open 属性来关闭下拉框
      } else {
        console.error("Could not find element for index:", index);
      }
    },
    handleDocumentClick(event) {
      // 检查点击是否发生在下拉框外部
      if (this.isOpen !== null) {
        const selects = this.$refs.selects;
        const currentSelect = selects[this.isOpen].$el; // 获取当前打开的下拉框 DOM 元素

        // 检查点击是否发生在当前下拉框内部
        if (!currentSelect.contains(event.target)) {
          console.log("Clicked outside dropdown, closing...");
          this.closeDropdown(this.isOpen); // 关闭当前下拉框
          this.isOpen = null; // 清空状态
        }
      }
    },
    findMatchingRows() {
      const targetValues = [
        "实际提成",
        "底薪津贴",
        "其他奖励",
        "其他扣款",
        "个人社保扣除",
        "个税扣除",
        "公司社保支付",
        "单位工作量"
      ];

      const rows = document.querySelectorAll("tr.order-flexs");

      rows.forEach(row => {
        const containsTargetValue = Array.from(row.cells).some(cell =>
            targetValues.includes(cell.textContent.trim())
        );

        if (containsTargetValue) {
          const orderTrTds = Array.from(row.cells).filter(cell => cell.classList.contains("order-tr"));
          orderTrTds.forEach(td => {
            td.style.backgroundColor = "#c1e2fd";
            td.classList.add('hover-effect'); // 添加悬停效果类
            const inputElement = td.querySelector("input");
            if (inputElement) {
              inputElement.style.backgroundColor = "#c1e2fd";
            }
          });
        }
      });
    },
    bank_oneChange(e) {
    },

    sendDataToBackend() {
      const table = document.querySelector('table');
      const theadRow = table.querySelector('thead tr');
      const tbodyRows = table.querySelectorAll('tbody tr');

      const tds = Array.from(theadRow.querySelectorAll('td'));
      const headerData = tds.slice(0, 7).map(td => { // 处理前六个元素
        const inputElement = td.querySelector('input');
        return inputElement ? inputElement.id : td.textContent.trim() || "";
      }).concat(
          tds.slice(6).reduce((acc, td) => { // 对第七个及之后的元素进行处理
            const inputElement = td.querySelector('input');
            const content = inputElement ? inputElement.id : td.textContent.trim();
            if (content !== '') { // 只有当内容不是空字符串时才添加到结果数组中
              acc.push(content);
            }
            return acc;
          }, [])
      );

      console.log(headerData);  // 输出处理后的headerData

      const rowData = Array.from(tbodyRows).reduce((acc, row) => {
        const cells = Array.from(row.querySelectorAll('td')).map((cell) => {
          let targetInputElement;

          // 情况1：直接查找 td 内的 input 元素
          targetInputElement = cell.querySelector('input');
          if (targetInputElement) {
            return targetInputElement.getAttribute('id') || targetInputElement.value;
          }

          // 情况2：查找 class 为 my-row 的元素，无论是 div 还是 td
          const myRowElement = cell.querySelector('.my-row');
          if (myRowElement) {
            targetInputElement = myRowElement.querySelector('input');
            if (targetInputElement) {
              return targetInputElement.getAttribute('id') || targetInputElement.value;
            }
          }

          return cell.textContent.trim();
        });

        console.log(cells, 312312);

        // 如果这一行的所有单元格都是空字符串，则跳过
        if (cells.some(cell => cell !== '')) {
          acc.push(cells);
        }

        return acc;
      }, []);

      const combinedData = {
        headerData,
        rowData
      };
      // 在这里进行重复检查
      const spanValues = new Set();
      let isDuplicate = false;

      rowData.forEach((data) => {
        const spanValue = data;
        if (spanValues.has(spanValue)) {
          isDuplicate = true;
          return;
        }
        spanValues.add(spanValue);
      });

      const dateTimeString = this.value0;
      const dateTime = new Date(dateTimeString);
      const timestampInSeconds = Math.floor(dateTime.getTime() / 1000);

      if (isDuplicate) {
        alert('存在重复的 spanValue');
      } else {
        if (this.jsbm && timestampInSeconds) {
          SaveApi({
            AS: combinedData,
            id: this.jsbm,
            start: timestampInSeconds,
          }).then(res => {
            if (res.code == 1000) {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              //请求成功后重新获取数据
              this.getList()
            } else if (res.code == 1004) {
              this.$message.error(res.msg);
            }
            // 处理成功响应的逻辑
          }).catch(error => {
            // 处理错误响应的逻辑
          });
        } else {
          alert('请选择结算部门和时间')
        }
      }
    },

    rowEvt() {
      if (this.role == 8) {
        return;
      }
      // 获取表头行元素
      const theadRow = document.querySelector('thead tr');

      // 创建新的表头单元格
      const newHeaderCell = document.createElement('td');

      // 创建 select 元素
      const selectElement = document.createElement('select');
      selectElement.id = 'lecse_name';
      selectElement.name = 'selec_name';
      selectElement.style.width = '105px';
      selectElement.style.height = '300px';
      selectElement.style.outline = 'none';
      selectElement.style.border = 'none';
      selectElement.style.position = 'absolute'; // 设置绝对定位
      selectElement.style.display = 'none'; // 默认隐藏下拉菜单

      // 创建未选择的option元素
      const defaultOption = document.createElement('option');
      defaultOption.textContent = '';
      defaultOption.style.background = '#fff';
      selectElement.appendChild(defaultOption);

      // 添加员工选项
      this.staffItem.forEach((staff, index) => {
        const optionElement = document.createElement('option');
        optionElement.textContent = staff.name;
        optionElement.value = staff.id;
        optionElement.style.height = '30px'; // 设置每个选项的高度
        optionElement.style.padding = '7px 0'; // 添加垂直 padding
        optionElement.style.textIndent = '5px';
        optionElement.setAttribute('data-name', staff.name); // 添加自定义属性 data-name
        selectElement.appendChild(optionElement);
      });


      // 创建输入框
      const input = document.createElement('input');
      input.type = 'text';
      input.placeholder = '进行筛选';
      input.autocomplete = "off"
      input.style.width = "100px";
      input.style.border = "none";
      input.style.outline = "none";
      input.style.textIndent = '5px';
      input.style.cursor = 'pointer';


      // 绑定事件：当输入框获得焦点时，显示并模拟展开下拉菜单
      input.addEventListener('focus', () => {
        selectElement.style.display = 'block'; // 显示下拉菜单
        setTimeout(() => {
          selectElement.size = selectElement.options.length; // 模拟展开下拉列表
        }, 0);
      });

      // 绑定事件：当输入框内容变化时，进行筛选
      input.addEventListener('input', (event) => {

        const query = event.target.value.trim().toLowerCase(); // 获取输入框的值并转为小写

        let foundExactMatch = false;
        let exactMatchOptionValue = null;

        // 遍历 select 中的所有 option，根据输入内容显示或隐藏，并为每个选项绑定点击事件
        Array.from(selectElement.options).forEach(option => {
          const optionText = option.textContent.trim().toLowerCase(); // 获取 option 的文本并转为小写
          if (optionText === query) { // 检查是否存在完全匹配的选项
            foundExactMatch = true;
            exactMatchOptionValue = option.value; // 记录匹配项的 value
          }

          // 更新选项显示状态
          if (query === '' || optionText.includes(query)) {
            option.style.display = ''; // 显示匹配的选项或清空输入框时显示所有选项
          } else {
            option.style.display = 'none'; // 隐藏不匹配的选项
          }

          // 为选项绑定点击事件，确保可以点击选中
          option.onclick = () => {
            selectElement.value = option.value; // 设置 select 的值为当前点击的选项
            input.value = option.textContent; // 更新输入框的值为当前选项的文本
            selectElement.style.display = 'none'; // 隐藏下拉菜单

            // 触发 change 事件
            const changeEvent = new Event('change', {bubbles: true});
            selectElement.dispatchEvent(changeEvent);
          };
        });

        // 如果找到了精确匹配的选项，则自动选择该选项、更新 input 的 id，并手动隐藏下拉菜单
        if (foundExactMatch) {
          selectElement.value = exactMatchOptionValue;
          input.id = exactMatchOptionValue; // 设置 input 的 id 为匹配项的 value

          // 手动隐藏下拉菜单
          selectElement.style.display = 'none';
        }

        // 根据输入框的内容决定是否显示下拉菜单
        if (query !== '') {
          selectElement.style.display = 'block';
        } else {
          selectElement.style.display = 'block';
        }
      });


// 绑定事件：当下拉菜单失去焦点时，隐藏并恢复默认状态
      selectElement.addEventListener('blur', () => {
        setTimeout(() => {
          if (!selectElement.contains(document.activeElement)) {
            selectElement.style.display = 'none'; // 隐藏下拉菜单
            selectElement.size = 1; // 恢复默认大小
          }
        }, 100); // 延迟隐藏，避免用户点击选项时过早隐藏
      });

// 绑定事件：当选择一个选项时，更新输入框的值并隐藏下拉菜单
      selectElement.addEventListener('change', (event) => {
        const selectedOption = event.target.selectedOptions[0]; // 获取选中的 option
        if (selectedOption) { // 确保有选中的 option

          const selectedName = selectedOption.getAttribute('data-name'); // 获取 data-name 属性值
          const id_e = selectedOption.value; // 直接使用 .value 而不是 getAttribute

          input.value = selectedName; // 将 name 回显到输入框中
          input.id = id_e; // 设置 input 的 id

          selectElement.style.display = 'none'; // 隐藏下拉菜单
          selectElement.size = 1; // 恢复默认大小
        }
      });
      // 创建删除按钮
      const deleteButton = document.createElement('span');
      deleteButton.textContent = 'x';
      deleteButton.style.float = 'right';
      deleteButton.style.border = '1px solid #c9c2c2';
      deleteButton.style.borderRadius = '15px';
      deleteButton.style.background = '#dd117a';
      deleteButton.style.color = '#fff';
      deleteButton.style.width = '15px';
      deleteButton.style.height = '15px';
      deleteButton.style.fontSize = '11px';
      deleteButton.style.position = 'absolute';
      deleteButton.style.lineHeight = '11px';
      deleteButton.style.marginLeft = '-15px';
      deleteButton.style.cursor = 'pointer';
      deleteButton.style.top = '0px';

      deleteButton.style.opacity = '0'; // 默认隐藏删除按钮

      // 鼠标移入 input 时显示删除按钮
      newHeaderCell.addEventListener('mouseenter', () => {
        deleteButton.style.opacity = '1'; // 显示删除按钮
      });

      // 鼠标移出 input 时隐藏删除按钮
      newHeaderCell.addEventListener('mouseleave', () => {
        deleteButton.style.opacity = '0'; // 隐藏删除按钮
      });

      // 删除整列
      deleteButton.addEventListener('click', () => {
        console.log(32131231);

        const table = document.querySelector('table');
        const columnIndex = Array.from(theadRow.children).indexOf(newHeaderCell);
        const rows = Array.from(table.querySelectorAll('tr'));
        console.log(rows, 123);

        rows.forEach(row => {
          row.removeChild(row.children[columnIndex]);
        });
      });

      // 将元素添加到表头单元格
      newHeaderCell.appendChild(input);
      newHeaderCell.appendChild(deleteButton);
      newHeaderCell.appendChild(selectElement);
      theadRow.appendChild(newHeaderCell);

      // 设置新添加的列的样式
      newHeaderCell.style.border = '1px solid #c9c2c2';
      newHeaderCell.style.width = '60px';
      newHeaderCell.style.backgroundColor = '#c9f0de';
      newHeaderCell.classList.add('newCellClass');
      // 获取newHeaderCell下的所有input元素，并修改它们的背景颜色
      var inputs = newHeaderCell.querySelectorAll('input');
      inputs.forEach(function (input) {
        input.style.backgroundColor = '#c9f0de';
      });

      // 获取具有特定 class 的 table 元素
      const table = document.querySelector('.ma_ev');

      // 获取该 table 元素下的 tbody 中的所有行
      const tbodyRows = table.querySelectorAll('tbody tr');

      // 定义需要设置为白色的行索引
      const whiteRows = [0, 1, 4, 5, 12,];

      // 遍历表体行元素
      tbodyRows.forEach((row, rowIndex) => {
        // 创建新的表体单元格
        const newBodyCell = document.createElement('td');
        const newInput = document.createElement('input');
        newInput.type = 'text';
        newInput.style.border = 'none';
        newInput.style.outline = 'none';
        newInput.style.width = '80px';

        // 不为表体中的 input 绑定 focus 事件
        newBodyCell.appendChild(newInput);
        newBodyCell.classList.add('newCellClass'); // 添加一个 class 名字
        newBodyCell.style.border = '1px solid #c9c2c2';
        newBodyCell.style.width = '60px';

        row.appendChild(newBodyCell);

        // 判断当前行是否在需要设置为白色的行索引中
        if (whiteRows.includes(rowIndex)) {
          // 设置背景颜色为白色
          newBodyCell.style.backgroundColor = '#fff';
          newInput.style.backgroundColor = '#fff';
        } else {
          // 设置背景颜色为 #c1e2fd
          newBodyCell.style.backgroundColor = '#c1e2fd';
          newInput.style.backgroundColor = '#c1e2fd';
        }
      });

      // 监听全局点击事件，点击其他区域时关闭 select 菜单
      document.addEventListener('click', (event) => {
        const isClickInsideInput = input.contains(event.target);
        const isClickInsideSelect = selectElement.contains(event.target);

        if (!isClickInsideInput && !isClickInsideSelect) {
          selectElement.style.display = 'none'; // 隐藏下拉菜单
          selectElement.size = 1; // 恢复默认大小
        }
      });
    },

    coulunmEvt() {
      if (this.role == 8) {
        return;
      }
      // 获取表格的 tbody 元素
      const tbody = document.querySelector('tbody');

      // 获取当前表格的行数和列数
      const rowCount = tbody.children.length;
      const columnCount = tbody.children[0].children.length;

      // 创建新的行元素
      const newRow = document.createElement('tr');
      newRow.classList.add('newCellClass');

      // 动态创建每一列并设置背景颜色
      for (let i = 0; i < columnCount; i++) {
        const newCell = document.createElement('td');
        newCell.style.border = '1px solid #c9c2c2';
        newCell.style.height = '40px';
        newCell.style.position = 'relative';

        // 根据列号设置背景颜色
        if (i === 0) {
          // 第一列
          newCell.style.backgroundColor = '#c9f0de';
          newCell.innerHTML = `<input autocomplete="off" style="width:100%; height:100%; border:none; outline:none; background-color:#c9f0de;cursor: pointer;text-indent: 12px;" placeholder="请输入查询内容">`;
        } else if (i >= 1 && i <= 6) {
          // 第二到第六列
          newCell.style.backgroundColor = '#f1f8d3';
          newCell.innerHTML = `<input style="width:100%; height:100%; border:none; outline:none; background-color:#f1f8d3;text-align: center;">`;
        } else {
          // 其他列
          newCell.style.backgroundColor = '#c1e2fd';
          newCell.innerHTML = `<input style="width:100%; height:100%; border:none; outline:none; background-color:#c1e2fd;text-indent:8px">`;
        }

        // 添加单元格到新行
        newRow.appendChild(newCell);
      }

      // 将新行添加到 tbody
      tbody.appendChild(newRow);

      // 获取第一列的 input 和单元格
      const firstCell = newRow.children[0];
      const input = firstCell.querySelector('input');

      // 创建删除按钮
      const deleteButton = document.createElement('span');
      deleteButton.textContent = 'x';
      deleteButton.style.float = 'right';
      deleteButton.style.border = '1px solid #c9c2c2';
      deleteButton.style.borderRadius = '15px';
      deleteButton.style.background = '#dd117a';
      deleteButton.style.color = '#fff';
      deleteButton.style.width = '15px';
      deleteButton.style.height = '15px';
      deleteButton.style.fontSize = '11px';
      deleteButton.style.position = 'absolute';
      deleteButton.style.lineHeight = '11px';
      deleteButton.style.right = '10px';
      deleteButton.style.top = '0px';
      deleteButton.style.cursor = 'pointer';
      deleteButton.style.opacity = '0'; // 默认隐藏删除按钮

      // 鼠标移入 input 时显示删除按钮
      firstCell.addEventListener('mouseenter', () => {
        deleteButton.style.opacity = '1';
      });

      // 鼠标移出 input 时隐藏删除按钮
      firstCell.addEventListener('mouseleave', () => {
        deleteButton.style.opacity = '0';
      });

      // 点击删除按钮时删除整行
      deleteButton.addEventListener('click', () => {
        const row = deleteButton.parentNode.parentNode;
        row.parentNode.removeChild(row);
      });

      // 将删除按钮添加到第一个单元格
      firstCell.appendChild(deleteButton);

      // 创建 select 元素
      const select = document.createElement('select');
      select.id = 'lecse_name';
      select.name = 'selec_name';
      select.style.width = '300px';
      select.style.maxHeight = '300px';
      select.style.outline = 'none';
      select.style.border = '1px solid #ccc';
      select.style.position = 'absolute';
      select.style.display = 'none'; // 初始状态为隐藏
      select.style.backgroundColor = '#fff';
      select.style.zIndex = '1000';

      // 添加一个空白的 option
      const blankOption = document.createElement('option');
      blankOption.value = '';
      blankOption.textContent = '';
      blankOption.disabled = true;
      blankOption.selected = true;
      blankOption.style.background = '#fff';
      select.appendChild(blankOption);

      // 遍历 projectItem 数组并创建选项
      this.projectItem.forEach((item, index) => {
        const option = document.createElement('option');
        option.value = item.id;
        option.textContent = item.name;
        option.style.height = '30px';
        option.style.padding = '7px 0';
        option.style.textIndent = '5px';
        option.style.cursor = 'pointer';
        select.appendChild(option);
      });

      // 监听 input 的 focus 事件，显示 select 并定位
      input.addEventListener('focus', () => {
        setTimeout(() => {
          select.style.display = 'block';

          const cellRect = firstCell.getBoundingClientRect();
          const tbodyRect = tbody.getBoundingClientRect();

          select.style.position = 'absolute';
          select.style.left = `${cellRect.left - tbodyRect.left}px`;
          select.style.bottom = `${tbodyRect.bottom - cellRect.top}px`;

          select.size = this.projectItem.length;
          tbody.appendChild(select);
        }, 100);
      });

      // 处理 change 逻辑的统一函数
      const handleSelectChange = () => {
        const selectedOption = select.options[select.selectedIndex];
        console.log(selectedOption, 32131231);

        if (selectedOption) {
          input.value = selectedOption.textContent;
          console.log(input.value, 312312);

          input.id = selectedOption.value;

          const tdCell = input.parentElement;
          tdCell.classList.add('my-row');

          select.style.display = 'none';
          if (tbody.parentNode.contains(select)) {
            tbody.parentNode.removeChild(select);
          }
        }
      };

      // 绑定 change 事件
      select.addEventListener('change', handleSelectChange);

      // 监听 input 的 input 事件，动态过滤选项 & 自动匹配触发 change
      input.addEventListener('input', (event) => {
        if (!document.body.contains(select)) {
          console.warn("select 尚未插入 DOM");
          return;
        }

        const query = event.target.value.trim().toLowerCase();
        let foundOption = null;

        Array.from(select.options).forEach(option => {
          const optionText = option.textContent.trim().toLowerCase();
          if (optionText.includes(query)) {
            option.style.display = '';
            if (optionText === query) {
              foundOption = option;
            }
          } else {
            option.style.display = 'none';
          }
        });

        if (foundOption) {
          select.value = foundOption.value;
          const changeEvent = new Event('change', {bubbles: true});
          select.dispatchEvent(changeEvent);
        } else {
          select.style.display = 'block';

        }
      });

      // 监听全局点击事件，隐藏 select
      document.addEventListener('click', (event) => {
        // 检查点击的目标是否不是 `select` 和 `input`
        if (event.target !== select && event.target !== input) {
          // 获取选中的选项
          const selectedOption = select.options[select.selectedIndex];
          // 如果选中了某个选项
          if (selectedOption) {
            // 将选中的值更新到 input 中
            input.value = selectedOption.textContent;  // 或者 selectedOption.value 根据需要

            // 可选：如果需要，给 input 设置一个标识
            input.id = selectedOption.value;
          }
          // 隐藏 select 元素
          select.style.display = 'none';
        }
      });

    },
    submitForm() {
      // 提交表单逻辑
    },
    deleteForm() {
      // 删除表单逻辑
    },
    exportExcel() {
      // 导出Excel逻辑
      const dateTimeString = this.value0;
      const dateTime = new Date(dateTimeString);
      const timestampInSeconds = Math.floor(dateTime.getTime() / 1000);
      if (this.jsbm && timestampInSeconds) {
        let data = {
          id: this.jsbm,
          start: timestampInSeconds,
          excel: 1,
        };
        let genExcel = false;
        if (genExcel == false) {
          IndexApi(data).then((res) => {
            window.location.href = res
            genExcel = true
          });
        } else if (genExcel == true) {
          alert('正在生成数据请勿重复请求')
        }
      }

    },
    jsbmChange(value) {
      console.log('jsbmChange:', value);
      this.jsbm = value;

      // 只有当jsbm和日期都存在时才获取数据
      if (value && this.value0) {
        this.getList();
      }
    },

    getList() {
      // 基本校验
      if (!this.jsbm || !this.value0) {
        this.loading = false;
        return;
      }

      this.loading = true;

      try {
        // 日期处理
        const dateTime = new Date(this.value0);
        if (isNaN(dateTime.getTime())) {
          throw new Error('无效的日期格式');
        }

        const timestampInSeconds = Math.floor(dateTime.getTime() / 1000);

        const data = {
          id: this.jsbm,
          start: timestampInSeconds
        };

        IndexApi(data).then(res => {
          // 清空现有数据
          this.tableData = res.data || [];
          this.totalRow_one = res.data.total || 0;
          this.salary = res.data.salary || null;
          this.salaryProjects = res.data.salaryProjects || [];
          this.projectStaff = res.data.projectStaff || [];

          this.$nextTick(() => {
            this.findMatchingRows();
            // 清理自定义单元格
            document.querySelectorAll('.newCellClass').forEach(cell => {
              cell.remove();
            });
          });
        }).catch(err => {
          console.error('获取数据失败:', err);
        }).finally(() => {
          this.loading = false;
        });
      } catch (err) {
        console.error('处理数据时出错:', err);
        this.loading = false;
      }
    }
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../../style/Media_Query.less");

.el-main {
  left: 185px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

.edit {
  // width: 1000px;
  height: 40px;
  display: flex;

  div {
    width: 137px;
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    border: 1px solid #589ff9;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
  }

  /deep/ .el-input__icon {
    line-height: 0px;
  }
}


.table-header {
  width: 150px;
  height: 30px;
}

.table-cell {
  border: 1px solid;
}

.add-row-button,
.add-column-button {
  margin-top: 10px;
}

table {
  border-collapse: collapse;
  font-size: 14px;
}

th,
td {
  border: 1px solid rgb(199, 199, 199);
  padding: 5px 8px;
  width: 100px;
  height: 30px;
  font-size: 12px;
  min-width: 100px;
}


.clone_one {
  display: none;
  position: absolute;
  top: 1px;
  right: 5px;
}

td:hover .clone_one {
  display: block;
  cursor: pointer;
}


.order-list {
  font-size: 13px;
  border: 1px solid #e5e5e5;
  padding: 5px 30px;
  background-color: #589ff9;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.order-list:nth-child(2) {
  font-size: 13px;
  border: 1px solid #e5e5e5;
  padding: 5px 30px;
  margin-left: 5px;
}

.order_div {
  font-size: 13px;
  padding: 5px;
  margin-left: 15px;
}

.form_inline {
  /deep/ .el-icon-date:before {
    content: '',
  }
}

.btn {
  font-size: 13px;
  border: 1px solid #e5e5e5;
  padding: 3px 30px;
  margin-left: 5px;
  border-radius: 5px;
  cursor: pointer;
  background-color: #fff;
}

.my-row /deep/ .vs__selected {
  height: 30px;
  width: 270px !important;
  overflow: visible !important;
}

.my-row /deep/ .vs__selected-options {
  flex-wrap: nowrap !important;
}

.my-row /deep/ .vs__actions {
  opacity: 0 !important;
}

.my-select /deep/ .vs__selected-options {
  flex-wrap: nowrap !important;
}

.my-select /deep/ .vs__search {
  display: none !important;
}

.my-select /deep/ .vs__actions {
  display: none !important;
}

.my-row /deep/ .vs__clear {
  display: none !important;
}

.my-select /deep/ .vs__clear {
  display: none !important;
}

/deep/ .vs__dropdown-toggle {
  border: none !important;
}

.my-select /deep/ .vs__selected {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 60px;
  cursor: pointer;
}


.lie td {
  width: 80px !important;
}

.lie td:nth-child(1) {
  background-color: #c9f0de;

  /deep/ .vs__dropdown-toggle {
    background-color: #c9f0de;
  }

  /deep/ input {
    background-color: #c9f0de;
    outline: none;
    border: none;
  }
}

.lie td:nth-child(n+2):nth-child(-n+7) {
  background-color: #f1f8d3;
  cursor: alias !important;

  /deep/ .vs__dropdown-toggle {
    background-color: #c9f0de;
  }
}

.lie td {
  background-color: #c1e2fd;

  /deep/ .vs__dropdown-toggle {
    background-color: #c9f0de;
  }

  /deep/ input {
    background-color: #c1e2fd;
    outline: none;
    border: none;
  }
}

.fixed_e {
  background: #c9f0de;

  /deep/ input {
    background-color: #c9f0de;
    outline: none;
    border: none;
  }
}

.order-tr {
  /deep/ input {
    outline: none;
    border: none;
  }
}

#lecse_name option {
  padding: 10px 0 !important;
}

/deep/ .my-select .el-input__inner {
  height: 25px !important;
  line-height: 25px !important;
  border: none !important;
  padding: 0 0 !important;
}

.order-flexs .order-input:nth-child(1) {
  width: 300px !important;
}

/deep/ .my-select .el-input__suffix {
  display: none !important;
}

.ma_ev input {
  width: 100px !important;
}

/deep/ .my-row .el-input__suffix {
  display: none !important;
}


.ma_ev {
  border-collapse: collapse;
  width: max-content;
  position: relative;
}

.hover-effect:hover {
  background: #c9f0de !important;
}

.hover-effect:hover input {
  background: #c9f0de !important;
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/src/salary_management/Monthly_salary/index.vue